import { render } from "./VTextEditor.vue?vue&type=template&id=5711860d"
import script from "./VTextEditor.vue?vue&type=script&lang=js"
export * from "./VTextEditor.vue?vue&type=script&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/common/components/VTextEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5711860d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5711860d', __exports__)) {
    api.reload('5711860d', __exports__)
  }
  
  module.hot.accept("./VTextEditor.vue?vue&type=template&id=5711860d", () => {
    api.rerender('5711860d', render)
  })

}


export default __exports__